/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Invitation_2Inputs */

const en_flow_invitation_2 = /** @type {(inputs: Flow_Invitation_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The buyer books a visit from the invitation, in Frontrow.`)
};

/**
* | output |
* | --- |
* | "The buyer books a visit from the invitation, in Frontrow." |
*
* @param {Flow_Invitation_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_invitation_2 = /** @type {((inputs?: Flow_Invitation_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Invitation_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_invitation_2(inputs)
});